module.exports = __webpack_public_path__ + "img/tag-01.5ef4f819.svg";